import React, { useState, useEffect } from "react";

export function RangeSlider({ start, end, min, max, step, rangeType, range, updateRange, showLabel = true }){

  const [sliderOne, setSliderOne] = useState(start);
  const [sliderTwo, setSliderTwo] = useState(end);

  useEffect(() => {
    setSliderOne(start);
    setSliderTwo(end);
  }, [start, end]);

  const moveSlider = (event) => {
    var min
    var max
    if (event.target.id == "sliderOne" ) {
      setSliderOne(event.target.value)
      min = Math.min(event.target.value, sliderTwo)
      max = Math.max(event.target.value, sliderTwo)
    } else {
      setSliderTwo(event.target.value)
      min = Math.min(event.target.value, sliderOne)
      max = Math.max(event.target.value, sliderOne)
    }
    updateRange(rangeType, min, max)
  }

  return (
       <div className="range-form">
           {showLabel ? (
             <>
               <span className="key">FROM: </span>
               <span className="value">{range.min}</span>
               <span className="key"> TO: </span>
               <span className="value">{range.max}</span>
             </>
           ) : null}
           <div>
             <input type="range" min={min} max={max} value={sliderOne}
                    id="sliderOne" step={step} onChange={moveSlider}/>
             <input type="range" min={min} max={max} value={sliderTwo}
                    id="sliderTwo" step={step} onChange={moveSlider}/>
           </div>
       </div>
  );
}